import Lara from "@/presets/lara";

const baseDialogPt = Lara.dialog;
const baseInputSwitchPt = Lara.inputswitch;
const baseRadioButtonPt = Lara.radiobutton;

export const dialogPt = {
  ...baseDialogPt,
  root: (options) => ({
    class: [baseDialogPt.root(options).class, "overflow-hidden"],
  }),
};

export const inputSwitchPt = {
  slider: ({ props }) => {
    return {
      class: [
        ...baseInputSwitchPt.slider({ props }).class,
        {
          "!bg-indigo-base !dark:bg-indigo-base": props.modelValue === props.trueValue,
        },
        {
          "peer-hover:bg-indigo-base dark:peer-hover:bg-indigo-base":
            props.modelValue === props.trueValue && !props.disabled,
        },
        "peer-focus-visible:ring-indigo-base dark:peer-focus-visible:ring-indigo-base",
      ],
    };
  },
};

export const radioButtonPt = {
  root: {
    class: [...baseRadioButtonPt.root.class, "!w-[1.2rem] !h-[1.2rem]"],
  },
  box: ({ props }) => {
    const selected = props.value === props.modelValue && props.value !== undefined;

    return {
      class: [
        ...baseRadioButtonPt.box({ props }).class,
        "!w-[1.2rem] !h-[1.2rem]",
        {
          "!border-3 !border-transparent dark:!border-transparent": selected,
          "!bg-transparent dark:!bg-transparent": selected,
          "!border-3 peer-hover:!border-teal-700": !selected,
        },
        {
          "peer-focus-visible:!ring-teal-700/20 dark:peer-focus-visible:!ring-teal-700/20": !props.disabled,
        },
      ],
    };
  },
  icon: ({ props }) => {
    const selected = props.value === props.modelValue && props.value !== undefined;

    return {
      class: [
        ...baseRadioButtonPt.icon({ props }).class,
        {
          "!bg-teal-700 dark:!bg-teal-700": selected,
          "!ring-2 !ring-teal-700 dark:!ring-teal-700": selected,
          "!ring-offset-2 !ring-offset-teal-light dark:!ring-offset-teal-light": selected,
        },
        "!w-[0.7rem] !h-[0.7rem]",
      ],
    };
  },
};
